import { memo } from "react";
import { useActiveAgent } from "../../../../contexts/ActiveAgentContext";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from "../../../common/shadcn/select";
import AgentItem from "./agent-item";
import { View } from "react-native";
import { MapPin } from "lucide-react-native";

const AgentSelector = ({ className }: { className?: string }) => {
  const { activeAgent, setActiveAgentById, agents, hasNoAgents } =
    useActiveAgent();

  if (!agents || agents.length === 0 || hasNoAgents || !activeAgent)
    return null;

  return (
    <Select
      defaultValue={activeAgent?.id}
      onValueChange={setActiveAgentById}
      value={activeAgent?.id}
    >
      <SelectTrigger className={`md:min-w-[368px] h-12 ${className}`}>
        <SelectValue
          defaultValue={activeAgent?.id}
          placeholder="Select Location"
        >
          <View className="flex flex-row items-center">
            <MapPin
              size={14}
              color="#111827"
              className="mr-1.5 hidden sm:flex"
            />
            <AgentItem agent={activeAgent} showStatus />
          </View>
        </SelectValue>
      </SelectTrigger>
      <SelectContent>
        <SelectGroup>
          <SelectLabel className="border-b border-gray-200">
            Your Locations
          </SelectLabel>
          {agents.map((agent) => (
            <SelectItem
              key={agent.id}
              value={agent.id}
              className={`flex flex-col items-start py-4 gap-1 border-b border-gray-200 hover:bg-gray-100 cursor-pointer ${
                agent.id === activeAgent?.id
                  ? "bg-gray-100 hover:bg-gray-200 text-gray-800 hover:text-gray-950"
                  : ""
              }`}
            >
              <AgentItem agent={agent} showAddress showStatus />
            </SelectItem>
          ))}
        </SelectGroup>
      </SelectContent>
    </Select>
  );
};

export default memo(AgentSelector);
